import { Component, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef,DialogService } from 'primeng/dynamicdialog';
import { UnlicenseduserserviceService } from './unlicenseduserservice.service';
import { UnlicensedusermodalComponent } from '../../directives/unlicensedusermodal/unlicensedusermodal.component';
 import { Utilityservice } from '../../utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalMessage } from '../../utility/modals';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import Swal from 'sweetalert2';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-unlicenseduser',
  templateUrl: './unlicenseduser.component.html',
  styleUrls: ['./unlicenseduser.component.css']
})
export class UnlicenseduserComponent {
   constructor(
    public Utilityservice: Utilityservice,public helpservice:PagehelpmodalService,
    public dialogService: DialogService,     
    private spinner: NgxSpinnerService, private UnlicenseduserserviceService: UnlicenseduserserviceService,
  ) { 

     this.getDropdownList();
    this.dynamiccols();
    this.commonScrollHeight = this.Utilityservice.updateScrollHeight();
    this.excel_paragraph = this.message.downloadexcel_text;
  }
  message: GlobalMessage = new GlobalMessage();
  customsort: boolean = true;
  ref: DynamicDialogRef | undefined;
  filterProductData: Array<any> = [];
  excel_paragraph = '';
  filterStatusData: Array<any> = [];
  cols: any[];
  _selectedColumns: any[];
  hidecount: number = 0;
  selectedProduct: any = null;
  showcount: number = 0;
  selectedUserType: string = null;
  selectedActiveFlag: string = null;
  paginatorArray = [];
  formlistarray: Array<any> = [];
  commonScrollHeight = '';
  options = [{ label: 10, value: 10 }];
  filtersData = {
    tproducts: '',
    tactiveflag: '',
    tusertype: '',
    page: 1,
    size: 10,
  }
  currentPageIndex: number = 0;
  @ViewChild('dt') dt: any;
  rowsize: number = 10;
  totalRecords: number = 0;
  tablecount: number = 0;
  items: MenuItem[] | undefined; 
  templateModal = false; 
  searchTerm: string = ''; 

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  activeFlagOptions: Array<any> = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];
   

  openhelpmodal() {
    this.templateModal = true;
  }

  getParams2(event, label) {
    if (label == 'Products') {
      this.filtersData['tproducts'] = event.value
    }
    if (label == 'Active Flag') {
      this.filtersData['tactiveflag'] = event.value
    }
    if (label == 'User Type') {
      this.filtersData['tusertype'] = event.value
    }
    this.getDropdownList();
    this.getalldata()
  }

  dynamiccols() {
    this.cols = [
      { field: 'userName', header: 'User Name', type: 'text', sort: false, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "product", header: "Product", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "userEmail", header: "User Email", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "userType", header: "User Type", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdOn", header: "Created On", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "status", header: "Status", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },

    ]
    this._selectedColumns = this.cols;
    this.Utilityservice.headerObservable.next(this.cols);
    this.showcount = 4;
    this.hidecount = 2;
  }
  getDropdownList() {
    const getproductsPayload: any = {}
    if (this.filtersData['tproducts']) {
      getproductsPayload.productid = this.filtersData['tproducts']
    }
    if (this.filtersData['tusertype']) {
      getproductsPayload.userType = this.filtersData['tusertype']
    }
    if (this.filtersData['tactiveflag']) {
      getproductsPayload.activeStatus = this.filtersData['tactiveflag']
    }
    const products = this.UnlicenseduserserviceService.getproductfilter(getproductsPayload);
    products.subscribe(res => {
      this.filterProductData = res;
      this.filterProductData.unshift({ productid: '', productname: '' });
    });

    const getstatusPayload: any = {}
    if (this.filtersData['tproducts']) {
      getstatusPayload.productid = this.filtersData['tproducts']
    }
    if (this.filtersData['tusertype']) {
      getstatusPayload.userType = this.filtersData['tusertype']
    }
    if (this.filtersData['tactiveflag']) {
      getstatusPayload.activeStatus = this.filtersData['tactiveflag']
    }
    const statuses = this.UnlicenseduserserviceService.getstatus(getstatusPayload);
    statuses.subscribe(res => {
      this.activeFlagOptions = res;
      this.activeFlagOptions.unshift({ activeFlagId: '', activeFlagName: '' });
    });

    const getusertypePayload: any = {}
    if (this.filtersData['tproducts']) {
      getusertypePayload.productid = this.filtersData['tproducts']
    }
    if (this.filtersData['tusertype']) {
      getusertypePayload.userType = this.filtersData['tusertype']
    }
    if (this.filtersData['tactiveflag']) {
      getusertypePayload.activeStatus = this.filtersData['tactiveflag']
    }
    const userTypes = this.UnlicenseduserserviceService.getusertype(getusertypePayload);
    userTypes.subscribe(res => {
      this.userTypeOptions = res;
      this.userTypeOptions.unshift({ userTypeId: '', userTypeName: '' });
    });
  }

  userTypeOptions: Array<any> = [
    { label: 'Unlicensed Internal User', value: 'I' },
    { label: 'Unlicensed External User', value: 'E' }
  ];
  refreshFilters() {
    this.spinner.show();
    window.location.reload();
    this.spinner.hide();
  }

  ngOnInit() {
    this.getalldata();
  }

  deleteUser(userid: string): void {
    Swal.fire({
      title: 'Are you sure you want to delete this Unlicensed user?',
      text: 'Once deleted it cannot be recovered.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, I am sure',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.UnlicenseduserserviceService.deleteUser({ userid: userid }).subscribe(
          (response) => {
            Swal.fire('Unlicensed user deleted successfully!', '', 'success');
            this.getalldata();
            this.getDropdownList();
          },
          (error) => {
            console.error('Error response:', error);
            Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
          }
        );
      }
    });
  }

  getalldata() {
    const currentPageSize = this.rowsize;
    const product = this.filterProductData.find(e => e.productid === this.selectedProduct);
    const status = this.activeFlagOptions.find(e => e.activeFlagId === this.selectedActiveFlag);
    const userType = this.userTypeOptions.find(e => e.userTypeId === this.selectedUserType);
    const payload: any = {
    };
    if (product) {
      payload.productid = product.productid
    }
    if (status) {
      payload.status = status.activeFlagId
    }
    if (userType) {
      payload.userType = userType.userTypeId
    } 
    const defaultRowsize = 10;
    this.UnlicenseduserserviceService.getalldata(payload).subscribe({
    next: (data: any[]) => {

      this.formlistarray = data.map(item => ({ ...item, isSelect: false }));

      this.totalRecords = this.formlistarray.length;
      this.tablecount = this.totalRecords;

      this.rowsize = this.totalRecords < defaultRowsize ? this.totalRecords : defaultRowsize;
      this.options = this.Utilityservice.getOptionDropdown(this.totalRecords);
      this.paginatorArray = this.options.map(e => e.value);

      if (!this.paginatorArray.includes(this.rowsize)) {
        this.paginatorArray.push(this.rowsize);
      }

      this.paginatorArray = this.paginatorArray
        .filter(v => v <= this.totalRecords)
        .sort((a, b) => a - b);

      this.currentPageIndex = 0;
      setTimeout(() => {
        if (this.dt) {
          this.dt.first = this.currentPageIndex;
        }
      }, 0);

    }
    
    })
  }


  getSelectedProductTooltip(): string {
    const selected = this.filterProductData.find(item => item.productid === this.selectedProduct);
    return selected ? selected.productname : 'Select Product';
  }

  getSelectedFlagTooltip(): string {
    const selected = this.activeFlagOptions.find(item => item.activeFlagId === this.selectedActiveFlag);
    return selected ? selected.activeFlagName : 'Select Flag';
  }

  getSelectedUserTypeTooltip(): string {
    const selected = this.userTypeOptions.find(item => item.userTypeId === this.selectedUserType);
    return selected ? selected.userTypeName : 'Select User Type';
  }




  exceDownloadModel() {
    let payload = {}
    if (this.filtersData) {
      payload = this.filtersData;
    }
    const width = this.Utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '45vw',
      height: '25vh',
      data: {
        excelname: "Unlicensed_User_details.xlsx", downloadapi: 'common/unlicensedusers/getexceldata',
        method: 'post', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      maximizable: false,
      position: 'center'
    })
  }
  show(title, data, deleteFlag) {
    let details = {};
    this.currentPageIndex = this.dt?.first || 0;
    if (title != 'Modify Unlicensed User') {
      details = {};
      this.ref = this.dialogService.open(UnlicensedusermodalComponent, {
        header: title,
        width: '60vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 1000,
        maximizable: false,
        position: 'center'
      });
      this.ref.onClose.subscribe((res) => {
       // this.callFilterMethod();
        this.getalldata();
            this.getDropdownList();
      });
    }
    if (title === 'Modify Unlicensed User') {
      this.UnlicenseduserserviceService.getmodify(data.userid).subscribe((res: any) => {
        if (!res || res.length === 0 || res[0].response) {
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            icon: 'error',
            title: 'Invalid Data',
            text: res[0]?.response || 'Data not found'
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(UnlicensedusermodalComponent, {
            header: title,
            width: '51vw',
            height: 'auto',
            data: { title: title, datas: details, deleteFlag: deleteFlag },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 1000,
            maximizable: false,
            position: 'center'
          });
          this.ref.onClose.subscribe(() => {
            this.getalldata();
            this.getDropdownList();
          });
        }
      }, error => {

        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })
      })
    }
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
